import { useEffect, useRef, useState } from "react";
import { CardWrapper, CardTitle, CardBody, CardButton } from "./style";

export const TreeCard = ({
  title = "title",
  content = "content",
  buttonText = "choose",
  id = null,
  onClick = () => {},
}) => {
  return (
    <CardWrapper {...{ id, onClick }}>
      <CardTitle>{title}</CardTitle>
      <CardBody>{content}</CardBody>
      {/* <CardButton {...{ onClick }}>{buttonText}</CardButton> */}
    </CardWrapper>
  );
};
